module.exports = __webpack_public_path__ + "media/images/zen-nurse-783fac1f1668175b151305a4a0a09224.svg";